import { BehaviorSubject } from 'rxjs';
import url from "./../components/variables/url.js";

const APP_ID = process.env.REACT_APP_ID;
const localBack = url.localBack;
const cas = url.cas

const currentUser = {
  usuario: "",
  idpersona: 0,
  identificacion: "",
  ultimoCambio: "",
  apellidos: "",
  nombres: "",
  roles: [],
  token: ""
};

const currentUserSubject = new BehaviorSubject(currentUser);

export const authService = {
  login,
  logout,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() { return currentUserSubject.value },
};

function login(username) {
  fetch(localBack + "account", {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ idapp: APP_ID, netid: username })
  })   

  .then(response => response.json().then(data => ({ok: response.ok, body: data})))
  .then((result) => {
    if(!result.ok){
      logout();
    }else{
      const body = result.body
    let loggedUser = {
      idpersona: body.user.idpersona,
      usuario: body.user.netId,
      identificacion: body.user.numeroidentificacion,
      apellidos: body.user.apellidos,
      nombres: body.user.nombres,
      roles: body.user.roles,
      token: body.token
    };

    let realFetch = window.fetch;
      window.fetch = function (url, opts = null) {
          let headers = opts.headers;
          console.log(headers);
      if (loggedUser.token) {
          headers = Object.assign({}, headers, { 'Authorization': `Bearer ${loggedUser.token}` });
          if (url.indexOf('File') < 0 && headers['Content-Type'] == undefined) {
              console.log(url);
              headers = Object.assign({}, headers, { 'Content-Type': 'application/json' });
          }
          opts.headers = headers;
        return realFetch(url, opts);
      } else {
        return realFetch(url, opts);
      }
    };
    currentUserSubject.next(loggedUser);
    }
    
  });
}

function logout() {
  // remove user and go to logout CAS
  currentUserSubject.next(null);
  window.location.href = cas+"/logout";
}